import axios from 'axios'

const stripe = { 
  getCheckout: (sub_id) => axios.get(
    `${process.env.REACT_APP_API_URL}stripe/create-checkout-session?sub_id=${sub_id}`
  ).then( res => res.data ),
  getStatus: (session_id) =>axios.get(
    `${process.env.REACT_APP_API_URL}stripe/session-status?session_id=${session_id}`
  ).then( res => res.data ),
  getBillingPortal: (session_id) => axios.get(
    `${process.env.REACT_APP_API_URL}stripe/open-billing-portal?session_id=${session_id}`
  ).then( res => res.data ),
}
export default stripe